import {makeStyles} from '@material-ui/core/styles';

export default makeStyles(theme => ({
    buttonsWrapper: {
        flexWrap: 'wrap',
        margin: `-${theme.spacing(1) / 2}px -${theme.spacing(1)}px`,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    button: {
        padding: 6,
        flex: 1,
        fill: 'black',
        fillOpacity: 0.7,
    },
    explorerRoundButton: {
        padding: 4,
        flex: 1,
        fillOpacity: 1,
    },
    explorerGreyButton: {
        padding: 4,
        flex: 1,
        color: 'black',
        background: '#00000011',
    },
    explorerBlackRoundButton: {
        color: 'black !important',
        padding: 4,
        flex: 1,
        fillOpacity: 0.7,
    },
    actionButton: {
        flex: '1 1 0px',
        padding: 6,
        whiteSpace: 'nowrap',
        fontWeight: 700,
        '@media (max-width:320px)': {
            '& svg': {
                display: 'none',
            },
        },
    },
}));
